/**
 * True in the browser bundle.
 *
 * Replaces process.env.WEBPACK, which only ever existed because webpack's DefinePlugin
 * put it there. Nothing replaces it under Vite's dev server, so the browser hit a bare
 * `process` and threw - and a build time flag was the wrong question anyway: what the
 * call sites want to know is whether there is a window.
 */
export const isBrowser = typeof window !== "undefined";

/**
 * Development mode, decided at runtime so it works the same under Vite, tsx and plain
 * node - none of which agree on what is available at build time.
 *
 * In the browser the signal is the server's own: the production HTML writes
 * window.BUILD_INFO before the entry module runs, the development HTML does not.
 */
export const isDevelopment = isBrowser
    ? !window.BUILD_INFO
    : process.env.NODE_ENV === "development";

export const isProduction = !isDevelopment;
